import React from 'react';
import './Pagination.css';

function Pagination({ total, hasNext, hasPrev, onNextPage, onPrevPage }) {
  return (
    <div className="pagination">
      <button
        className="pagination-button"
        onClick={onPrevPage}
        disabled={!hasPrev}
      >
        Previous
      </button>
      <span className="pagination-info">
        Found {total} result(s)
      </span>
      <button
        className="pagination-button"
        onClick={onNextPage}
        disabled={!hasNext}
      >
        Next
      </button>
    </div>
  );
}

export default Pagination;
